export const FAQData = [
    {
        id: 1,
        question: "How long is the course access?",
        answer: "The course videos and practice problems come with a lifetime access. Access it anytime, anywhere.",
    },
    {
        id: 2,
        question: "What are the pre-requisites for the courses?",
        answer: "There are as such no pre-requisites for the courses here. We have designed each of the courses in such a way that anyone with a basic understanding of the subject can learn from it.",
    },
    {
        id: 3,
        question: "What if I have doubts?",
        answer: "We have a dedicated team for doubt support who are there to help you out with your doubts. You can reach out to them via the discussion forum or through our Discord Server.",
    },
    {
        id: 4,
        question: "Will there be any Certificate of completion?",
        answer: "Yes, you will get an instructor signed certificate from Udemy after finishing this course..",
    },
]